import { Tag } from "antd";

export const CustomTag = ({ value, config, isPayment = false }: { value: string, config: any, isPayment?: boolean }) => {
  const lowerValue = value?.toLowerCase();
  
  // Para Status que tiene objeto {color, label}
  if (config[lowerValue]?.color) {
    return <Tag color={config[lowerValue].color} style={{ borderRadius: '12px', fontWeight: 500 }}>
      {config[lowerValue].label.toUpperCase()}
    </Tag>;
  }

  // Para Pago y Entrega que son strings directos
  return (
    <Tag 
      color={config[lowerValue] || 'default'} 
      style={{ borderRadius: '12px', fontWeight: 500, textTransform: 'uppercase' }}
    >
      {value}
    </Tag>
  );
};